const hydratedMenus = new WeakSet<HTMLElement>()

export function hydrateMenuStripes(
  container: Document | Element = document
): void {
  const menus = container.querySelectorAll<HTMLElement>('.vssl-stripe--menu')

  menus.forEach((menuEl) => {
    if (hydratedMenus.has(menuEl)) return
    hydratedMenus.add(menuEl)

    // Collapsible menu
    if (!menuEl.getAttribute('data-collapsible')) return

    if (!menuEl.parentElement) return

    const menuElIndex = Array.from(menuEl.parentElement.children).indexOf(
      menuEl
    )
    const firstLevel = menuEl.querySelectorAll<HTMLElement>(
      '.vssl-stripe--menu--listitem[data-depth="1"]'
    )

    if (!firstLevel || !firstLevel.length) return

    firstLevel.forEach((item, index) => {
      const nested = item.querySelector<HTMLUListElement>('ul[data-depth="2"]')

      if (!nested) return

      const linkNumbers = `${menuElIndex}-${index}`
      nested.id = `vssl-stripe-menu-${linkNumbers}`
      nested.setAttribute('hidden', 'true')

      let ariaLabel = 'menu'
      let link = item.querySelector<HTMLElement>(
        '.vssl-stripe--menu--link[data-depth="1"]'
      )

      if (!link) return

      // Set up button (whether or not it replaces link)
      const button = document.createElement('button')
      button.classList.add('vssl-stripe--menu--button')
      button.setAttribute('aria-expanded', 'false')
      button.setAttribute('aria-controls', `vssl-stripe-menu-${linkNumbers}`)

      // Convert link to button
      if (menuEl.getAttribute('data-with-first-level-links-as-buttons')) {
        button.classList.add('vssl-stripe--menu--link')
        const linkText = link.querySelector('.vssl-stripe--menu--link--text')
        if (linkText) {
          button.appendChild(linkText)
        }
        button.setAttribute('data-depth', '1')
        link.replaceWith(button)
        link = button
        ariaLabel += ' for ' + link.innerText
      } else {
        button.classList.add('vssl-stripe--menu--expand-button')
        if (link.nextSibling && link.parentNode) {
          link.parentNode.insertBefore(button, link.nextSibling)
        } else if (link.parentNode) {
          link.parentNode.appendChild(button)
        }
      }

      button.setAttribute('aria-label', `Expand ${ariaLabel}`)

      // Add arrow to link/button
      const icon = document.createElement('span')
      icon.classList.add('vssl-stripe--menu--expand-icon')
      icon.setAttribute('aria-hidden', 'true')
      button.appendChild(icon)

      // Add click event to open/close nested menu
      button.addEventListener('click', (e) => {
        e.preventDefault()
        if (nested.getAttribute('hidden')) {
          nested.removeAttribute('hidden')
          button.setAttribute('aria-label', `Collapse ${ariaLabel}`)
          button.setAttribute('aria-expanded', 'true')
          window.dispatchEvent(new CustomEvent('vssl-stripe-menu-open'))
        } else {
          nested.setAttribute('hidden', 'true')
          button.setAttribute('aria-label', `Expand ${ariaLabel}`)
          button.setAttribute('aria-expanded', 'false')
          window.dispatchEvent(new CustomEvent('vssl-stripe-menu-close'))
        }
        window.dispatchEvent(new CustomEvent('vssl-stripe-menu-resize'))
      })
    })

    // Dispatch resize event on DOMContentLoaded
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function onLoad() {
        window.dispatchEvent(new CustomEvent('vssl-stripe-menu-resize'))
        document.removeEventListener('DOMContentLoaded', onLoad)
      })
    } else {
      window.dispatchEvent(new CustomEvent('vssl-stripe-menu-resize'))
    }
  })
}
